import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, NgZone, OnDestroy, OnInit, Output, RendererFactory2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ExamConfirmationComponent } from './exam-confirmation/exam-confirmation.component';
import { DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SwalService } from 'projects/shared/src/services/swal.service';

@Component({
  selector: 'app-exam-preview',
  templateUrl: './exam-preview.component.html',
  standalone: false
})
export class ExamPreviewComponent implements OnInit, OnDestroy {
  @ViewChild('fullscreenElement', { static: true }) fullscreenElement!: ElementRef;
  isFullScreenLocked: boolean = false;
  @Input() moduleLessonId: number;
  @Output() submitEvent = new EventEmitter<boolean>();
  @Input() customClass: string = '';
  @Input() isExam: boolean = false;
  isPageReloaded = 0;

  constructor(
    private ngZone: NgZone,
    public dialog: MatDialog,
    private translate: TranslateService,
    private swalService: SwalService,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {
    // if (sessionStorage.getItem('refreshCount') !== null) {
    //   this.isPageReloaded = JSON.parse(sessionStorage.getItem('refreshCount') as string);
    // } else {
    //   sessionStorage.setItem('refreshCount', JSON.stringify(0));
    // }
  }

  ngOnInit(): void {
    if (localStorage.getItem('canAccessExam') && localStorage.getItem('canAccessExam') == 'true') {
      this.router.navigate(['/']);
    } else {
      localStorage.setItem('canAccessExam', 'false');

      window.addEventListener('focus', this.onFocus);
      window.addEventListener('blur', this.onBlur);
      // window.addEventListener("unload", (event) => {
      //   alert('dsads')
      //   console.log(event)
      // });
      // window.addEventListener("beforeunload", (event) => {
      //   // console.log(this.isFullscreen())
      //   // console.log(event)
      //   // // Recommended
      //   // event.preventDefault();

      //   this.isPageReloaded++;
      //   sessionStorage.setItem('refreshCount', String(this.isPageReloaded));
      //   // this.toggleFullscreen();
      //   setTimeout(() => {

      //   }, 1000);
      //   // Included for legacy support, e.g. Chrome/Edge < 119
      //   event.stopPropagation();
      //   prompt('dsadsadadsa')
      // });
      window.focus();
      this.toggleFullscreen();
      // if (sessionStorage.getItem('refreshCount') && Number(sessionStorage.getItem('refreshCount'))) {
      //   // sessionStorage.removeItem('refreshCount');
      //   // this.router.navigateByUrl('/admin/anatomic-pathology-exams-trainee/82', { replaceUrl: true });
      // }
      // document.dispatchEvent(new Event("click"));
    }
  }

  toggleFullscreen() {
    console.log(this.isFullscreen())
    if (document.fullscreenElement && this.isFullScreenLocked) {
      // this.exitFullscreen();
      // this.isFullScreenLocked = false;
    } else {
      this.enterFullscreen(this.fullscreenElement.nativeElement);
      this.lockScreen();
    }
  }

  isFullscreen(): boolean {
    return (
      document.fullscreenElement !== null ||
      (document as any).webkitFullscreenElement !== null ||
      (document as any).mozFullScreenElement !== null ||
      (document as any).msFullscreenElement !== null
    );
  }

  enterFullscreen(element: any) {
    const methodToBeInvoked = element.requestFullscreen ||
      element.webkitRequestFullScreen || element.mozRequestFullscreen || element.msRequestFullscreen;
    if (methodToBeInvoked) { methodToBeInvoked.call(element); }
  }

  exitFullscreen() {
    console.log(document)
    if ((document as any).exitFullscreen) {
      (document as any).exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  }


  lockScreen() {
    this.isFullScreenLocked = true;
  }

  unlockScreen() {
    this.isFullScreenLocked = false;
    this.exitFullscreen();
  }

  onFocus = (): void => {
    this.ngZone.run(() => {
      console.log('Window gained focus');
      // Your logic when window gains focus
    });
  };

  onBlur = (e): void => {
    this.ngZone.run(() => {
      // this.isConfirmationAccepted = window.confirm('Do you really want to leave the page?');
      if (this.isFullScreenLocked) {
        this.confirmationDialog();
      }
      console.log('Window lost focus');
      // Your logic when window loses focus
    });
  };

  @HostListener("document:fullscreenchange", ["$event"])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  onFullScreenChange(event: KeyboardEvent): void {
    // Check if the document is not in fullscreen mode
    if (!document.fullscreenElement && this.isFullScreenLocked) {
      this.confirmationDialog();
      console.log('fullscreenchange')
    }
    // if (document.fullscreenElement && this.isFullScreenLocked) {
    //   this.exitFullscreen();
    //   this.isFullScreenLocked = false;
    // }
  }

  // Prevent Specific Keyboard Shortcuts
  @HostListener('document:keydown', ['$event'])
  preventKeys(event: KeyboardEvent) {
    if (this.isFullScreenLocked) {
      const keysToDisable = ['F12', 'F5', 'Alt', 'Tab', 'Control', 'Shift', 'Escape'];
      if (keysToDisable.includes(event.key) || (event.ctrlKey && event.key === 'u')) {
        event.preventDefault();
      }
    }
  }

  confirmationDialog() {
    this.dialog.closeAll();
    if (('speechSynthesis' in window)) {
      window.speechSynthesis.cancel();
      // console.log(window.speechSynthesis)
    }
    const dialogRef = this.dialog.open(ExamConfirmationComponent, {
      width: '550px',
      disableClose: true,
      data: {
        moduleLessonId: this.moduleLessonId,
        isExam: this.isExam
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.exitFullscreen();
        this.isFullScreenLocked = false;
        this.swalService.swalFailed(this.translate.instant('exam.examEnded'));
        this.submitEvent.emit(true);
      } else {
        if (!document.fullscreenElement && this.isFullScreenLocked) {
          this.enterFullscreen(this.fullscreenElement.nativeElement);
        }
        // If the user does not confirm, bring the window back into focus
        setTimeout(() => {
          window.focus(); // Attempt to bring the window back into focus
        }, 0);
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('focus', this.onFocus);
    window.removeEventListener('blur', this.onBlur);
  }
}
